import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a12d4cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2a12d4cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12d4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a12d4cc')) {
      api.createRecord('2a12d4cc', component.options)
    } else {
      api.reload('2a12d4cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a12d4cc&scoped=true&", function () {
      api.rerender('2a12d4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contentCenter/consumerCoupon/index.vue"
export default component.exports